import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProduitService } from '../../services/produit.service';

@Injectable()
export class InstanceEtProduitResolver implements Resolve<Observable<string>> {

  constructor(
    private produitService: ProduitService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    const url_instance = route.paramMap.get('url_instance');
    const id_offre_emploi = route.paramMap.get('id_offre_emploi');

    let request;
    if (url_instance) {
      request = this.produitService.getInstanceEtProduit(url_instance);
    } else if (id_offre_emploi) {
      request = this.produitService.getInstanceEtProduitFromOffre(id_offre_emploi);
    }
    return request.pipe(map(
      (res) => {
        return res;
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
